import apiClient from 'utilities/api-client';

export async function fetchNDIADebtorId() {
  return await apiClient.get('/api/portal/account/ndia-debtor-info');
}
